import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CInput,
  CRow
} from "@coreui/react";
import React from "react";

const OtherQuickSearch = (props) => {

  const handleOtherQuickSearch = (event) => {
    event.preventDefault();
    props.handleSearch();
  }

  return (
    <>
      <CCard>
        <CCardBody>
          <CRow>
            <CCol sm="5">
              <div className="small text-muted">Enter Search Value:</div>
            </CCol>
            <CCol sm="7" className="d-none d-md-block">
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="8">
              <CInput type="text"
                      name="searchValue" value={props.searchValue}
                      onChange={props.handleSearchValue} required/>
            </CCol>
            <CCol sm="4" className="d-none d-md-block">
              <CButton color="primary"
                       className="px-4 btn-block"
                       onClick={handleOtherQuickSearch}>Search</CButton>
            </CCol>
          </CRow>
          {props.validationError &&
          <CRow>
            <CCol sm="8">
              <div className="invalidField">{props.validationError}</div>
            </CCol>
          </CRow>
          }
        </CCardBody>
      </CCard>
    </>
  )
}

export default OtherQuickSearch;
